import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import React from 'react'

import { replaceDotWithComma } from '@js/common/utils'

import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

export const AreaInformation = () => {
  const {
    state: { outside_measurements_length, outside_measurements_width }
  } = useHouseDetail()

  return (
    <Box sx={{ pb: 2 }}>
      <Box sx={{ py: 1 }}>
        <Typography variant='bodyTitle' component='p'>
          {t('houseDetailPage.floor_plans.area-header')}
        </Typography>
      </Box>
      <Area>
        {outside_measurements_length && (
          <AreaText variant='body2'>
            {t('houseDetailPage.floor_plans.length', {
              length: replaceDotWithComma(outside_measurements_length)
            })}
          </AreaText>
        )}
        {outside_measurements_width && (
          <AreaText variant='body2'>
            {t('houseDetailPage.floor_plans.width', {
              width: replaceDotWithComma(outside_measurements_width)
            })}
          </AreaText>
        )}
      </Area>
    </Box>
  )
}

const Area = styled(Box)`
  width: 100%;
  display: flex;
`

const AreaText = styled(Typography)`
  &:last-child&:not(:first-of-type) {
    padding-left: ${({ theme }) => theme.spacing(4)};
  }
`
